/* Lightweight wishlist heart toggle for product cards.
   Stores saved product IDs in localStorage (key tl_wishlist_v1).
   The full wishlist drawer / header count can be wired to the same key later. */
(function () {
  var KEY = 'tl_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }

  function mark() {
    var ids = read();
    var hearts = document.querySelectorAll('.tl-wishlist-heart[data-tl-wishlist]');
    for (var i = 0; i < hearts.length; i++) {
      var id = String(hearts[i].getAttribute('data-tl-wishlist'));
      hearts[i].setAttribute('aria-pressed', ids.indexOf(id) !== -1 ? 'true' : 'false');
    }
  }

  var raf;
  function scheduleMark() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(mark);
  }

  // Capture phase so we beat the parent product link and prevent navigation.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.tl-wishlist-heart') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = String(btn.getAttribute('data-tl-wishlist'));
    var ids = read();
    var idx = ids.indexOf(id);
    if (idx === -1) { ids.push(id); } else { ids.splice(idx, 1); }
    write(ids);
    btn.setAttribute('aria-pressed', idx === -1 ? 'true' : 'false');
    document.dispatchEvent(new CustomEvent('tl:wishlist:changed', { detail: { ids: ids } }));
  }, true);

  if (document.readyState !== 'loading') { mark(); }
  document.addEventListener('DOMContentLoaded', mark);
  document.addEventListener('shopify:section:load', mark);
  window.addEventListener('pageshow', mark);

  // Re-mark cards added by collection filtering / pagination.
  if (window.MutationObserver && document.body) {
    new MutationObserver(scheduleMark).observe(document.body, { childList: true, subtree: true });
  }

  /* --- skeleton cleanup ---------------------------------------------------
     The theme's card images carry animate-Xpulse/skeleton-image loading
     classes that an inline onload is supposed to remove. On AJAX-rendered
     cards (featured-collection tabs, filtered collection grids) that onload
     sometimes never fires, and the leftover pulse animation overrides the
     hover opacity:0 on the first image — it lingers half-transparent above
     the hover image and reads as a gray veil. Sweep any already-loaded
     image and also catch late loads via a capture-phase listener. */
  function clearSkeleton(img) {
    if (img.complete && img.naturalWidth > 0) {
      img.classList.remove('animate-Xpulse', 'skeleton-image');
    }
  }
  function sweepSkeletons() {
    var imgs = document.querySelectorAll('img.skeleton-image');
    for (var i = 0; i < imgs.length; i++) { clearSkeleton(imgs[i]); }
  }
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.classList && t.classList.contains('skeleton-image')) {
      t.classList.remove('animate-Xpulse', 'skeleton-image');
    }
  }, true);
  if (document.readyState !== 'loading') { sweepSkeletons(); }
  document.addEventListener('DOMContentLoaded', sweepSkeletons);
  setTimeout(sweepSkeletons, 1500);
  setTimeout(sweepSkeletons, 4000);
  if (window.MutationObserver && document.body) {
    var skelRaf;
    new MutationObserver(function () {
      if (skelRaf) cancelAnimationFrame(skelRaf);
      skelRaf = requestAnimationFrame(sweepSkeletons);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
